import React, { useContext, useState } from "react";
import "./Navbar.css";
import logo from "/images/logo.png";
import { useNavigate } from "react-router-dom";
import { RiMenu2Fill } from "react-icons/ri";
import { AuthContext } from "../../context/Authcontext";
import { toast } from "sonner";
import { Link } from "react-router-dom";
const Navbar = () => {
  const [activeLink, setActiveLink] = useState(window.location.pathname);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const { token, fullName, emailVerify, phoneVerify, phoneNumber, emailInfo } = useContext(AuthContext);
  const navigate = useNavigate();
  const handleLinkClick = (path) => {
    setActiveLink(path);
    setIsOverlayOpen(false);
  };
  const handleApplyNowClick = () => {
    const isEmailVerified = !!emailVerify;
    const isPhoneVerified = !!phoneVerify;


    if (token && (!isEmailVerified || !isPhoneVerified)) {
      toast.error("Please verify your email and phone before accessing the dashboard.");
      sessionStorage.clear();
      navigate("/login");
      return;
    }

    if (token && fullName && isEmailVerified && isPhoneVerified) {
      navigate("/dashboard");
      return;
    }

    navigate("/login");
  };


  return (
    <nav className="navbar navbar-expand-lg  border-bottom">
      <div className="container">
        <a className="navbar-brand d-flex align-items-center" href="/">
          <img src={logo} className="me-2" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNavbar"
          aria-controls="mainNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <RiMenu2Fill className="fs-4" />
        </button>

        {/* Menu Items */}
        <div className="collapse navbar-collapse" id="mainNavbar">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item ms-2">
              <Link
                className={`nav-link ${activeLink === "/eligible" ? "active" : ""
                  }`}
                to="/eligible"
                onClick={() => handleLinkClick("/eligible")}
              >
                Am I Eligible?
              </Link>
            </li>
            <li className="nav-item ms-2">
              <Link
                className={`nav-link ${activeLink === "/correctionworkflow" ? "active" : ""
                  }`}
                to="/correctionworkflow"
                onClick={() => handleLinkClick("/correctionworkflow")}
              >
                Correction Workflow
              </Link>
            </li>
            <li className="nav-item ms-2">
              <Link
                className={`nav-link ${activeLink === "/verificationflow" ? "active" : ""
                  }`}
                to="/verificationflow"
                onClick={() => handleLinkClick("/verificationflow")}
              >
                Verification Workflow
              </Link>
            </li>
            <li className="nav-item d-flex align-items-center ms-lg-3">
              <button className="apply_button" onClick={(e) => {
                e.preventDefault();  // Important!
                handleApplyNowClick();
              }}>
                {token ? "Dashboard" : "Login"}
              </button>
            </li>


            <li className="nav-item ms-4 flex d-flex justify-content-center align-items-center">
              <RiMenu2Fill
                className="fs-4 menubutton"
                onClick={() => setIsOverlayOpen(!isOverlayOpen)}
              />
            </li>
          </ul>
          {isOverlayOpen && (
            <div className="overlay-menu">
              <button
                className="close-btn"
                onClick={() => setIsOverlayOpen(false)}
              >
                &times;
              </button>
              <ul className="overlay-nav">
                <li className="listing-overlay">
                  <a href="/" onClick={() => handleLinkClick("/")}>
                    Home
                  </a>
                </li>
                <li className="listing-overlay">
                  <Link
                    to="/eligible"
                    onClick={() => handleLinkClick("/eligible")}
                  >
                    Eligibility Criteria
                  </Link>
                </li>
                <li className="listing-overlay">
                  <a href="https://laptop.pmyp.gov.pk/pdf_file/eligible_universities_list_by_hec.pdf" onClick={() => handleLinkClick("#")}>
                    Eligibility Public Universities
                  </a>
                </li>
                <li className="listing-overlay">
                  <Link
                    to="/focalperson"
                    onClick={() => handleLinkClick("/focalperson")}
                  >
                    Search Focal Person
                  </Link>
                </li>
                <li className="listing-overlay">
                  <Link
                    to="/applicationStatus"
                    onClick={() => handleLinkClick("/applicationStatus")}
                  >
                    Application Status
                  </Link>
                </li>
                <li className="listing-overlay">
                  <Link
                    to="/faq"
                    onClick={() => handleLinkClick("/frequentlyquestions")}
                  >
                    FAQs
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
